import { Environment } from "../../snippets/helpers";

export enum Type {
    IMPROVEMENT = "IMP",
    FEATURE = "FEAT",
    BUG = "BUG",
}

export enum Source {
    PHONE = "phone",
    REDEMPTION = "redemption",
    KIOSK = "kiosk",
    TABLET = "tablet",
    DESKTOP = "desktop",
}

export interface Feedback {
    sellerId: string;
    type: Type;
    source: Source;
    priority: number;
    problem: string;
    suggestedSolution?: string;
    estimatedOccurencePeriod?: string; // in ISO time period format.
    reportedAt: Date;
    clientInfo: ClientInfo;
}

export interface ClientInfo {
    appName: string; // mobile app name or "web" for web UI
    appVersion: string; // mobile app or web UI version
    environment?: Environment;
    timezone?: string; // timezone of the reporting client (mobile app or web page).
    installDate?: Date; // mobile app install date / web app release date
    deviceName?: string; // mobile device name if applicable
    deviceType?: string; // mobile device type if applicable
    operatingSystem?: string; // mobile app or browser OS
    userAgent?: string; // browser user agent if applicable
    fullStorySessionUrl?: string;
    sumoLogSessionId?: string;
    screenResolution?: {
        width: number; // screen width in pixels
        height: number; // screen height in pixels
    };
    storage?: {
        usedMb: number;
        totalMb: number;
    };
    memory?: {
        usedMb: number;
        totalMb: number;
    };
    battery?: {
        levelPercentage: number;
    };
}

export const defaultFeedbackData: Feedback = {
    sellerId: "",
    type: Type.BUG,
    source: Source.DESKTOP,
    priority: 100,
    problem: "",
    reportedAt: new Date(),
    clientInfo: {
        appName: "",
        appVersion: "",
    },
};
